import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1168.73678,487.896592 C1213.40893,446.495887 1282.56052,451.008226 1287.6369,451.233843 L1576.9906,451.121034 L1583.30787,33.6169213 L1539.651,22.9001175 C1511.6745,16.0188014 1426.05288,0 1237.32432,0 C901.26792,0 675.425382,235.20564 675.425382,585.137485 L675.425382,679.106933 L337,679.106933 L337,1130.34078 L675.425382,1130.34078 L675.425382,1920 L1126.65922,1920 L1126.65922,1130.34078 L1483.35958,1130.34078 L1545.40423,679.106933 L1126.65922,679.106933 L1126.65922,609.955347 C1126.65922,555.017626 1140.87309,513.842538 1168.73678,487.896592",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFacebookSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconFacebookSolid, _Component);

  var _super = _createSuper(IconFacebookSolid);

  function IconFacebookSolid() {
    _classCallCheck(this, IconFacebookSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconFacebookSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFacebook",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFacebookSolid.displayName = "IconFacebookSolid";
  return IconFacebookSolid;
}(Component);

IconFacebookSolid.glyphName = 'facebook';
IconFacebookSolid.variant = 'Solid';
IconFacebookSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFacebookSolid;
export { IconFacebookSolid };